import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Building2, Plug, Bot, Sparkles, CalendarDays, LogOut, Bell, Users } from 'lucide-react';
import useAuthStore from '../store/authStore';
import api from '../services/apiClient';
import { Logo } from './Logo';
import CompanyLogo from './CompanyLogo';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/empresas', label: 'Empresas', icon: Building2 },
  { to: '/usuarios', label: 'Usuários', icon: Users, adminOnly: true },
  { to: '/conexoes', label: 'Conexões', icon: Plug },
  { to: '/ia', label: 'Agente', icon: Bot },
  { to: '/gerar', label: 'Gerar conteúdo', icon: Sparkles },
  { to: '/calendario', label: 'Calendário', icon: CalendarDays }
];

export default function AppShell({ children }) {
  const { user, companies, currentCompany, switchCompany, logout } = useAuthStore();
  const navigate = useNavigate();
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    let active = true;
    const fetchNotif = () => api.get('/notifications')
      .then((d) => { if (active) setNotifCount(d.total || 0); })
      .catch(() => {});
    fetchNotif();
    const t = setInterval(fetchNotif, 60000);
    return () => { active = false; clearInterval(t); };
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = (user?.name || '?').trim().slice(0, 1).toUpperCase();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand"><Logo /></div>

        <div className="sb-company">
          <CompanyLogo url={currentCompany?.logoUrl} name={currentCompany?.name} size={30} />
          <select
            className="sb-select"
            value={currentCompany?.id || ''}
            onChange={(e) => switchCompany(Number(e.target.value))}
          >
            {companies.length === 0 && <option value="">— nenhuma empresa —</option>}
            {companies.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <nav>
          {NAV.filter((item) => !item.adminOnly || user?.role === 'admin').map((item) => {
            const Icon = item.icon;
            return (
              <NavLink key={item.to} to={item.to} end={item.end}>
                <Icon size={18} /> <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="spacer" />

        <nav>
          <a className="sb-notif" onClick={() => navigate('/notificacoes')} style={{ cursor: 'pointer' }}>
            <Bell size={18} /> <span>Notificações</span>
            {notifCount > 0 && <span className="sb-badge">{notifCount}</span>}
          </a>
        </nav>

        <div className="sb-user">
          <span className="avatar">{initials}</span>
          <div className="sb-user-info">
            <div className="nm">{user?.name}</div>
            <div className="rl">{user?.role === 'admin' ? 'Administrador' : 'Operador'}</div>
          </div>
          <button className="sb-logout" onClick={handleLogout} title="Sair"><LogOut size={17} /></button>
        </div>
      </aside>

      <div className="main">
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
